/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderDetailReturnInfoVo
 */
export interface OrderDetailReturnInfoVo {
    /**
     * 收货人姓名
     * @type {string}
     * @memberof OrderDetailReturnInfoVo
     */
    receiverName?: string;
    /**
     * 收货人手机号
     * @type {string}
     * @memberof OrderDetailReturnInfoVo
     */
    mobileNo?: string;
    /**
     * 收货人邮政编码
     * @type {string}
     * @memberof OrderDetailReturnInfoVo
     */
    zip?: string;
    /**
     * 收货人地址
     * @type {string}
     * @memberof OrderDetailReturnInfoVo
     */
    address?: string;
    /**
     * 收货人详细地址
     * @type {string}
     * @memberof OrderDetailReturnInfoVo
     */
    addressDetail?: string;
    /**
     * 退货备注
     * @type {string}
     * @memberof OrderDetailReturnInfoVo
     */
    remark?: string;
    /**
     * 退货订单 取货方式1 仓库快递 2 卖家回收
     * @type {number}
     * @memberof OrderDetailReturnInfoVo
     */
    returnFetchGoodsMethod?: number;
    /**
     * 退货订单取货码
     * @type {string}
     * @memberof OrderDetailReturnInfoVo
     */
    returnFetchGoodsCode?: string;
    /**
     * 退货订单取货时间
     * @type {string}
     * @memberof OrderDetailReturnInfoVo
     */
    returnFetchGoodsDate?: string;
}

/**
 * Check if a given object implements the OrderDetailReturnInfoVo interface.
 */
export function instanceOfOrderDetailReturnInfoVo(value: object): value is OrderDetailReturnInfoVo {
    return true;
}

export function OrderDetailReturnInfoVoFromJSON(json: any): OrderDetailReturnInfoVo {
    return OrderDetailReturnInfoVoFromJSONTyped(json, false);
}

export function OrderDetailReturnInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDetailReturnInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'receiverName': json['receiverName'] == null ? undefined : json['receiverName'],
        'mobileNo': json['mobileNo'] == null ? undefined : json['mobileNo'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'address': json['address'] == null ? undefined : json['address'],
        'addressDetail': json['addressDetail'] == null ? undefined : json['addressDetail'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'returnFetchGoodsMethod': json['returnFetchGoodsMethod'] == null ? undefined : json['returnFetchGoodsMethod'],
        'returnFetchGoodsCode': json['returnFetchGoodsCode'] == null ? undefined : json['returnFetchGoodsCode'],
        'returnFetchGoodsDate': json['returnFetchGoodsDate'] == null ? undefined : json['returnFetchGoodsDate'],
    };
}

export function OrderDetailReturnInfoVoToJSON(json: any): OrderDetailReturnInfoVo {
    return OrderDetailReturnInfoVoToJSONTyped(json, false);
}

export function OrderDetailReturnInfoVoToJSONTyped(value?: OrderDetailReturnInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'receiverName': value['receiverName'],
        'mobileNo': value['mobileNo'],
        'zip': value['zip'],
        'address': value['address'],
        'addressDetail': value['addressDetail'],
        'remark': value['remark'],
        'returnFetchGoodsMethod': value['returnFetchGoodsMethod'],
        'returnFetchGoodsCode': value['returnFetchGoodsCode'],
        'returnFetchGoodsDate': value['returnFetchGoodsDate'],
    };
}

